import * as React from 'react';

import { useAuthorizationContext } from 'src/components/authorization';
import { goToNextPageIfPossible } from 'src/core/yup';
import { isRegistrationMode } from './utils/env';

const RegistrationRoutes = React.lazy(
  () =>
    import(
      /* webpackChunkName: "registration-routes" */
      'src/routes/RegistrationRoutes'
    ),
);

const AuthorizedUserRoutes = React.lazy(
  () =>
    import(
      /* webpackChunkName: "authorized-user-routes" */
      'src/routes/AuthorizedUserRoutes'
    ),
);

const UnauthenticatedUserRoutes = React.lazy(
  () =>
    import(
      /* webpackChunkName: "unauthenticated-user-routes" */
      'src/routes/UnauthenticatedUserRoutes'
    ),
);

export interface AppRouterProps {}

function AppRouter(props: AppRouterProps) {
  const { accessToken } = useAuthorizationContext();

  React.useEffect(() => {
    if (!accessToken) {
      return;
    }

    goToNextPageIfPossible();
  }, [accessToken]);

  if (isRegistrationMode()) {
    return <RegistrationRoutes />;
  }

  if (accessToken) {
    return <AuthorizedUserRoutes />;
  }

  return <UnauthenticatedUserRoutes />;
}

export default AppRouter;
